import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export const UpsellItemButton = Pressable.withConfig({
  width: '$72',
  minHeight: '$24',
  backgroundColor: getDesignToken('background-card'),
  borderWidth: 0.5,
  borderColor: primitive.$blackOpacity30,
  borderRadius: primitive.$borderRadius,
  marginRight: 4,
  alignItems: 'center',
  justifyContent: 'space-around',
  flexDirection: 'row',
  paddingX: 2,
});

export const UpsellItemName = withTypography({
  variant: 'headerFour',
  m: '$0',
  fontSize: 14,
  numberOfLines: 2,
});

export const UpsellItemPrice = withTypography({ fontSize: 'sm' });

export const UpsellItemCalories = withTypography({ fontSize: 'sm', style: { flexShrink: 1 } });

export const UpsellSectionContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [
      styles.upsellSectionContainer,
      isDesktop && styles.upsellSectionContainerDesktop,
      style,
    ],
  });
};

export const UpsellTitle = withTypography({
  accessible: true,
  focusable: true,
  variant: 'headerThree',
  mb: '$5',
});

export const UpsellItemPicture = Picture.withConfig({
  width: '$16',
  height: '$16',
  marginRight: '$2',
});

export const UpsellItemDetails = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.upsellItemDetails, style],
  });

const styles = StyleSheet.create({
  upsellItemDetails: {
    flex: 3,
    marginHorizontal: 1,
  },
  upsellSectionContainer: {
    marginBottom: spacing.$2,
  },
  upsellSectionContainerDesktop: {
    marginBottom: spacing.$4,
  },
});
